"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.checkBusinessCabin = checkBusinessCabin;
exports.checkDomestic = checkDomestic;
exports.checkDomesticKSA = checkDomesticKSA;
exports.checkEconomyCabin = checkEconomyCabin;
exports.checkMultiCity = checkMultiCity;
exports.checkOneWay = checkOneWay;
exports.checkRoundTrip = checkRoundTrip;
exports.default = void 0;
exports.formSearchQueryFromDates = formSearchQueryFromDates;
exports.getCabinTypeFromQuery = getCabinTypeFromQuery;
exports.getDepartureDateFromQuery = getDepartureDateFromQuery;
exports.getFlexibleDate = getFlexibleDate;
exports.getParamsFromQuery = getParamsFromQuery;
exports.getParsedSearchQuery = getParsedSearchQuery;
exports.getPaxFromQuery = getPaxFromQuery;
exports.getRequestLegFromQuery = getRequestLegFromQuery;
exports.getReturnDateFromQuery = getReturnDateFromQuery;
exports.getRouteFromQuery = getRouteFromQuery;
exports.getSearchStringWithFilters = getSearchStringWithFilters;
exports.getSearchTypeFromQuery = getSearchTypeFromQuery;
exports.replacePaxInQuery = replacePaxInQuery;
exports.validatePax = validatePax;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _queryString = _interopRequireDefault(require("query-string"));
var _each2 = _interopRequireDefault(require("lodash/each"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _replace2 = _interopRequireDefault(require("lodash/replace"));
var _split6 = _interopRequireDefault(require("lodash/split"));
var _startCase2 = _interopRequireDefault(require("lodash/startCase"));
var _toLower2 = _interopRequireDefault(require("lodash/toLower"));
var _toUpper2 = _interopRequireDefault(require("lodash/toUpper"));
var _values2 = _interopRequireDefault(require("lodash/values"));
var _last2 = _interopRequireDefault(require("lodash/last"));
var _max2 = _interopRequireDefault(require("lodash/max"));
var _min2 = _interopRequireDefault(require("lodash/min"));
var _constants = require("../constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function checkRoundTrip(query) {
  var queryArray = (0, _split6.default)(query, '/');
  return !!(queryArray[2] && _constants.QUERY_DATE_REGEX.test(queryArray[2]));
}
function checkOneWay(query) {
  var queryArray = (0, _split6.default)(query, '/');
  return !!(queryArray[1] && _constants.QUERY_DATE_REGEX.test(queryArray[1]) && !(0, _includes2.default)(queryArray[2], '-'));
}
function checkDomesticKSA(query) {
  var _split2 = (0, _split6.default)(getRouteFromQuery(query), '-'),
    originId = _split2[0],
    destinationId = _split2[1];
  return _constants.DOMESTIC_AIRPORTS.includes((0, _toUpper2.default)(originId)) && _constants.DOMESTIC_AIRPORTS.includes((0, _toUpper2.default)(destinationId));
}
function checkDomestic(query) {
  var isRoundTrip = checkRoundTrip(query);
  return isRoundTrip && checkDomesticKSA(query);
}
function checkMultiCity(query) {
  var queryArray = (0, _split6.default)(query, '/');
  var hasFirstDate = queryArray[1] && _constants.QUERY_DATE_REGEX.test(queryArray[1]);
  var hasAnotherDate = queryArray[3] && _constants.QUERY_DATE_REGEX.test(queryArray[3]);
  return !!(hasFirstDate && hasAnotherDate);
}
function checkEconomyCabin(query) {
  return (0, _includes2.default)((0, _toLower2.default)(query), '/economy/');
}
function checkBusinessCabin(query) {
  return (0, _includes2.default)((0, _toLower2.default)(query), '/business/');
}
function getParamsFromQuery(query) {
  var _split3 = (0, _split6.default)(query, '/'),
    iata = _split3[0],
    departureDate = _split3[1],
    restQueryArray = _split3.slice(2);
  var _split4 = (0, _split6.default)(iata, '-'),
    originId = _split4[0],
    destinationId = _split4[1];
  var isRoundTrip = checkRoundTrip(query);
  var isOneWay = checkOneWay(query);
  var returnDate = isRoundTrip && restQueryArray[0];
  var cabin = getCabinTypeFromQuery(query);
  var flexibleDate = getFlexibleDate(query);
  return {
    originId: originId,
    destinationId: destinationId,
    departureDate: departureDate,
    returnDate: returnDate,
    cabin: cabin,
    isRoundTrip: isRoundTrip,
    isOneWay: isOneWay,
    flexibleDate: flexibleDate
  };
}
function validatePax(paxTypeCount) {
  var paxAdult = paxTypeCount.adult > 0 ? paxTypeCount.adult : 0;
  var paxChild = paxTypeCount.child > 0 ? paxTypeCount.child : 0;
  var paxInfant = paxTypeCount.infant > 0 ? paxTypeCount.infant : 0;
  var totalTravellers = (0, _min2.default)([paxAdult + paxChild, _constants.SEARCH_BOX_CONSTANTS.MAX_PAX_COUNT]);
  var adult = (0, _max2.default)([(0, _min2.default)([paxAdult, totalTravellers]), _constants.SEARCH_BOX_CONSTANTS.MIN_ADULTS_COUNT]);
  var child = (0, _max2.default)([totalTravellers - adult, _constants.SEARCH_BOX_CONSTANTS.MIN_CHILDREN_COUNT]);
  var infant = (0, _max2.default)([(0, _min2.default)([paxInfant, adult]), _constants.SEARCH_BOX_CONSTANTS.MIN_INFANTS_COUNT]);
  return {
    adult: adult,
    child: child,
    infant: infant
  };
}
function replacePaxInQuery(query, newPaxQuery) {
  var queryArray = (0, _split6.default)(query, '/');
  var paxStartIndex = queryArray.findIndex(function (item) {
    return (0, _includes2.default)(item, 'Adult') || (0, _includes2.default)(item, 'Child') || (0, _includes2.default)(item, 'Infant');
  });
  if (paxStartIndex !== -1) {
    queryArray.splice(paxStartIndex, queryArray.length - paxStartIndex, newPaxQuery);
  } else {
    queryArray.push(newPaxQuery);
  }
  return queryArray.join('/');
}
function getPaxFromQuery(query) {
  var queryArray = (0, _split6.default)(query, '/');
  var pax = {
    adult: 0,
    child: 0,
    infant: 0
  };
  (0, _each2.default)(_constants.TRAVELLERS_TYPES_MAP, function (type) {
    var paxTypeLabel = (0, _toLower2.default)((0, _get2.default)(type, 'label'));
    var paxTypeQuery = queryArray.find(function (item) {
      return (0, _includes2.default)((0, _toLower2.default)(item), paxTypeLabel);
    });
    var paxTypeCount = Number((0, _replace2.default)((0, _toLower2.default)(paxTypeQuery), paxTypeLabel, ''));
    pax[paxTypeLabel] = isNaN(paxTypeCount) ? 0 : paxTypeCount;
  });
  return validatePax(pax);
}
function getParsedSearchQuery(query) {
  var queryParams = getParamsFromQuery(query);
  var passengers = getPaxFromQuery(query);
  return _objectSpread(_objectSpread(_objectSpread({}, queryParams), passengers), {}, {
    isMultiCity: checkMultiCity(query),
    pax: (0, _get2.default)(passengers, 'adult', 0) + (0, _get2.default)(passengers, 'child', 0) + (0, _get2.default)(passengers, 'infant', 0)
  });
}
function getRouteFromQuery(query) {
  return (0, _split6.default)(query, '/')[0];
}
function getDepartureDateFromQuery(query) {
  var departureDate = (0, _split6.default)(query, '/')[1];
  return _constants.QUERY_DATE_REGEX.test(departureDate) ? departureDate : undefined;
}
function getReturnDateFromQuery(query) {
  return checkRoundTrip(query) ? (0, _split6.default)(query, '/')[2] : undefined;
}
function getCabinTypeFromQuery(query) {
  var stringMatches = (0, _startCase2.default)(query).match(_constants.CABIN_TYPES_REGEX);
  return (0, _get2.default)(stringMatches, '0', _constants.CABIN_TYPES.ECONOMY);
}
function getSearchTypeFromQuery(query) {
  switch (true) {
    case checkOneWay(query):
      return _constants.SEARCH_TYPES.ONE_WAY;
    case checkRoundTrip(query):
      return _constants.SEARCH_TYPES.ROUND_TRIP;
    case checkMultiCity(query):
      return _constants.SEARCH_TYPES.MULTI_CITY;
    default:
      return _constants.SEARCH_TYPES.ONE_WAY;
  }
}
function getRequestLegFromQuery(query) {
  var queryItems = (0, _split6.default)(query, '/');
  var routes = queryItems.filter(function (queryItem) {
    return _constants.ROUTE_REGEX.test(queryItem);
  });
  var dates = queryItems.filter(function (queryItem) {
    return _constants.QUERY_DATE_REGEX.test(queryItem);
  });
  var preferredCabin = getCabinTypeFromQuery(query);
  var legs = (0, _map2.default)(routes, function (route, index) {
    var _route$split = route.split('-'),
      originId = _route$split[0],
      destinationId = _route$split[1];
    return {
      index: index,
      originId: originId,
      destinationId: destinationId,
      departure: dates[index],
      preferredCabin: preferredCabin
    };
  });
  if (checkRoundTrip(query)) {
    var _split5 = (0, _split6.default)(routes[0], '-'),
      destinationId = _split5[0],
      originId = _split5[1];
    legs.push({
      index: 1,
      originId: originId,
      destinationId: destinationId,
      departure: dates[1],
      preferredCabin: preferredCabin
    });
  }
  return legs;
}
function getSearchStringWithFilters(searchString, filtersQueryString) {
  var filteredSearchObject = (0, _omit2.default)(_queryString.default.parse(searchString), (0, _values2.default)(_constants.FILTER_PARAMS_MAP));
  var filtersQueryObject = _queryString.default.parse(filtersQueryString);
  return _queryString.default.stringify(_objectSpread(_objectSpread({}, filteredSearchObject), filtersQueryObject), {
    encode: false
  });
}
function formSearchQueryFromDates(query, departureDate, returnDate) {
  var queryArray = (0, _split6.default)(query, '/');
  var isRoundTrip = checkRoundTrip(query);
  queryArray[1] = departureDate;
  if (isRoundTrip) {
    queryArray[2] = returnDate;
  }
  return queryArray.filter(function (param) {
    return param !== _constants.SEARCH_BOX_CONSTANTS.FLEX_1D;
  }).join('/');
}
function getFlexibleDate(query) {
  var queryArray = (0, _split6.default)(query, '/');
  if (checkOneWay(query)) {
    var last = (0, _last2.default)(queryArray);
    return !!(last && _constants.FLEX_DATE_REGEX.test(last)) && last;
  }
  return false;
}
var _default = exports.default = {
  checkMultiCity: checkMultiCity,
  checkEconomyCabin: checkEconomyCabin,
  getDepartureDateFromQuery: getDepartureDateFromQuery,
  getReturnDateFromQuery: getReturnDateFromQuery,
  getRouteFromQuery: getRouteFromQuery,
  getParsedSearchQuery: getParsedSearchQuery,
  getParamsFromQuery: getParamsFromQuery
};